import React from "react";

const PlaybackRateIcon = () => {
  return (
    <svg
      className="playback-rate-icon-svg"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M33.14 33.109a.647.647 0 01-.494.224h-1.834c-.704 0-1.039-1.146-.538-1.64a8.934 8.934 0 10-12.549 0c.502.494.167 1.64-.537 1.64h-1.834a.647.647 0 01-.494-.224A11.954 11.954 0 0112 25.333c0-6.627 5.372-12 12-12s12 5.373 12 12c0 2.966-1.077 5.682-2.86 7.776z"
        fill="currentColor"
      />
      <path
        d="M29.2 22.34a.667.667 0 000-.943l-.944-.942a.667.667 0 00-.942 0l-2.865 2.864a.138.138 0 01-.117.038 2.333 2.333 0 101.975 1.956.138.138 0 01.038-.118l2.854-2.855z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlaybackRateIcon;
